<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    role="group"
    class='agpr-block'
    [ngClass]="{
        'agpr-block--editing': editing,
        'agpr-block--cannot-move': !block.canMove,
        'agpr-block--disabled': !block.actionable
    }"
    [attr.aria-label]="'Pagebuilder.block.label' | localize: { index: +blockPosition + 1, type: block.type?.label }"
    [attr.aria-describedby]="id + '_errors'"
    tabindex="0"
    (click)="onAction('edit')"
>
    @if (block.actionable) {
        @if (isInLayoutBlock || isInCuratorBlock) {
            @if (showMoveButtons && block.canMove) {
                <agpr-kebab-menu
                    #moveContextMenu
                    class="agpr-block-contextMenu agpr-block-contextMenu--topLeft agpr-block-inLayoutBlockMoveOptionsButton"
                    [id]="id + '_move'"
                    [style]="buttonTypes.contextMenu"
                    icon="fa-regular fa-arrows-up-down-left-right"
                    [panelPositionX]="panelPositions.left"
                    [options]="inLayoutBlockMovingOptions"
                    [showIcon]="true"
                    [loading]="null"
                    tooltip="PageBuilder.blockIcon.move"
                    tooltipPosition="top"
                    (panelShown)="onMenuOpened()"
                    [textAlignment]="actionMenuTextAlignment"
                ></agpr-kebab-menu>
            }
            <agpr-kebab-menu
                class="agpr-block-contextMenu agpr-block-contextMenu--topRight agpr-block-moreOptionsButton"
                [id]="id + '_moreOptions'"
                [style]="buttonTypes.contextMenu"
                [panelPositionX]="panelPositions.right"
                [options]="editingOptions"
                [showIcon]="true"
                [loading]="null"
                tooltip="PageBuilder.blockIcon.moreOptions"
                tooltipPosition="top"
                (panelShown)="onMenuOpened()"
                [textAlignment]="actionMenuTextAlignment"
            ></agpr-kebab-menu>
        } @else {
            @if (showMoveButtons && block.canMove) {
                <agpr-kebab-menu
                    #moveContextMenu
                    class="agpr-block-contextMenu agpr-block-contextMenu--topLeft agpr-block-contextMenu--topLeft--outside"
                    [id]="id + '_move'"
                    [style]="buttonTypes.contextMenu"
                    icon="fa-regular fa-arrows-up-down-left-right"
                    [panelPositionX]="panelPositions.left"
                    [disabled]="!block.canMoveUp && !block.canMoveDown"
                    [options]="movingOptions"
                    [showIcon]="true"
                    [loading]="null"
                    tooltip="PageBuilder.blockIcon.move"
                    tooltipPosition="top"
                    (panelShown)="onMenuOpened()"
                ></agpr-kebab-menu>
            }

            <ul
                role="menu"
                class="agpr-block-contextMenu agpr-block-contextMenu--topRight--outside"
                [attr.aria-label]="'PageBuilder.blockMenu.edit' | localize"
            >
                @if (block.canDuplicate) {
                    <li role="menuitem">
                        <agpr-button
                            class="agpr-block-contextButton"
                            [id]="id + '_duplicate'"
                            [style]="buttonTypes.contextMenu"
                            icon="fa-regular fa-duotone fa-clone"
                            tooltip="PageBuilder.briefings.blockIcon.duplicate"
                            tooltipPosition="top"
                            (click)="onAction('duplicate')"
                        ></agpr-button>
                    </li>
                }
                @if (block.canEdit) {
                    <li role="menuitem">
                        <agpr-button
                            class="agpr-block-contextButton"
                            [id]="id + '_edit'"
                            icon="fa-regular fa-duotone fa-pen"
                            [style]="buttonTypes.contextMenu"
                            tooltip="PageBuilder.briefings.blockIcon.edit"
                            tooltipPosition="top"
                            (click)="onAction('edit')"
                        ></agpr-button>
                    </li>
                }
                @if (block.canAddOrRemove) {
                    <li role="menuitem">
                        <agpr-button
                            class="agpr-block-contextButton agpr-block-contextButton--topRight"
                            [id]="id + '_delete'"
                            [style]="buttonTypes.contextMenu"
                            icon="fa-regular fa-duotone fa-trash-can"
                            tooltip="PageBuilder.briefings.blockIcon.delete"
                            tooltipPosition="top"
                            (click)="onAction('delete')"
                        ></agpr-button>
                    </li>
                }
            </ul>

            <ul
                #addToTop
                role="menu"
                class="agpr-block-contextMenu agpr-block-contextMenu--center-top"
                [ngClass]="{ 'agpr-block-contextMenu--hidden': addBottomExpanded }"
                [attr.aria-label]="'PageBuilder.blockMenu.add' | localize"
                (mouseleave)="leaveContextMenu(addToTop, $event, true)"
            >
                <li role="menuitem">
                    @if (inlineAdderAdjustment) {
                        <agpr-kebab-menu
                            class="agpr-block-contextButton agpr-block-contextButton--topLeft agpr-block-contextButton--topRight agpr-inline-addTop-button"
                            [id]="id + '_addTop_moreOptions'"
                            icon="fa-regular fa-duotone fa-plus"
                            [style]="buttonTypes.contextMenu"
                            [panelPositionX]="panelPositions.right"
                            [options]="optionsTop"
                            [showIcon]="true"
                            [loading]="null"
                            tooltip="PageBuilder.briefings.blockIcon.addBlock"
                            tooltipPosition="top"
                            ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toTop"
                            [panelAlignCenter]="true"
                            [textAlignment]="actionMenuTextAlignment"
                        ></agpr-kebab-menu>
                    }@else {
                        <agpr-button
                            class="agpr-block-contextButton agpr-block-contextButton--topLeft agpr-block-contextButton--topRight agpr-inline-addTop-button"
                            [id]="id + '_addTop'"
                            [style]="buttonTypes.contextMenu"
                            icon="fa-regular fa-duotone fa-plus"
                            tooltip="PageBuilder.briefings.blockIcon.addBlock"
                            tooltipPosition="top"
                            ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toTop"
                            [expanded]="addTopExpanded"
                            (click)="inlineAddToggle($event)"
                        >
                        </agpr-button>
                        <div
                            class="agpr-block-contextMenu-adderContainer"
                            (focusout)="leaveContextMenu(addToTop, $event)"
                        >
                            <div class="agpr-block-contextMenu-adder">
                                <label class="agpr-block-contextMenu-adder-header">{{ 'PageBuilder.inlineAdder.components' | localize | uppercase }}</label>
                                <agpr-block-adder
                                    [id]="id + '_above_' + blockAdderId"
                                    [addAtPosition]="blockPosition"
                                ></agpr-block-adder>
                                @if (areLayoutBlocksAllowed) {
                                    <label class="agpr-block-contextMenu-adder-header agpr-block-contextMenu-adder-header-layout">{{ 'PageBuilder.inlineAdder.layouts' | localize | uppercase }}</label>
                                    <agpr-layout-block-adder
                                        [id]="id + '_above_' + blockAdderId + '_layout'"
                                        [addAtPosition]="blockPosition"
                                        [isInline]="true"
                                    ></agpr-layout-block-adder>
                                }
                            </div>
                        </div>
                    }
                </li>
            </ul>
            @if (showMoveButtons && block.canMove) {
                <ul
                    #addToBottom
                    role="menu"
                    class="agpr-block-contextMenu agpr-block-contextMenu--center-bottom"
                    [ngClass]="{'agpr-block-contextMenu--hidden': addTopExpanded}"
                    [attr.aria-label]="'PageBuilder.blockMenu.add' | localize"
                    (mouseleave)="leaveContextMenu(addToBottom, $event, true)"
                >
                    <li role="menuitem">
                        @if (inlineAdderAdjustment) {
                            <agpr-kebab-menu
                                class="agpr-block-contextButton agpr-block-contextButton--bottomLeft agpr-block-contextButton--bottomRight"
                                [id]="id + '_addBottom_moreOptions'"
                                icon="fa-regular fa-duotone fa-plus"
                                [style]="buttonTypes.contextMenu"
                                [panelPositionX]="panelPositions.right"
                                [options]="optionsBottom"
                                [showIcon]="true"
                                [loading]="null"
                                tooltip="PageBuilder.briefings.blockIcon.addBlock"
                                tooltipPosition="top"
                                ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toBottom"
                                [panelAlignCenter]="true"
                                [textAlignment]="actionMenuTextAlignment"
                            ></agpr-kebab-menu>
                        }@else {
                            <agpr-button
                                class="agpr-block-contextButton agpr-block-contextButton--bottomLeft agpr-block-contextButton--bottomRight"
                                [id]="id + '_addBottom'"
                                [style]="buttonTypes.contextMenu"
                                icon="fa-regular fa-duotone fa-plus"
                                tooltip="PageBuilder.briefings.blockIcon.addBlock"
                                tooltipPosition="bottom"
                                ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toBottom"
                                [expanded]="addBottomExpanded"
                                (click)="inlineAddToggle($event)"
                            >
                            </agpr-button>
                            <div class="agpr-block-contextMenu-adderContainer">
                                <div
                                    class="agpr-block-contextMenu-adder"
                                    (focusout)="leaveContextMenu(addToBottom, $event)"
                                >
                                    <label class="agpr-block-contextMenu-adder-header">{{ 'PageBuilder.inlineAdder.components' | localize | uppercase }}</label>
                                    <agpr-block-adder
                                        [id]="id + '_below_' + blockAdderId"
                                        [addAtPosition]="blockPositionBottom"
                                    ></agpr-block-adder>
                                    @if (areLayoutBlocksAllowed) {
                                        <label class="agpr-block-contextMenu-adder-header agpr-block-contextMenu-adder-header-layout">{{ 'PageBuilder.inlineAdder.layouts' | localize | uppercase }}</label>
                                        <agpr-layout-block-adder
                                            [id]="id + '_below_' + blockAdderId + '_layout'"
                                            [addAtPosition]="blockPositionBottom"
                                            [isInline]="true"
                                        ></agpr-layout-block-adder>
                                    }
                                </div>
                            </div>
                        }
                    </li>
                </ul>
            }
        }
    }

    <div
        class="agpr-block-content"
        [attr.data-blocktype]="dataBlockType"
        [id]="id"
    >
        <div
            *ngIf="!renderable"
            class='agpr-block-placeholder'
            [style.line-height]="(block?.displayElement?.placeholderHeight ? (block?.displayElement?.placeholderHeight - 2) : 38 )+ 'px'"
        >
            <span class="fa agpr-block-placeholderIcon {{ block.type.icon }}" aria-hidden="true"></span>
            <span class="agpr-block-placeholderLabel">{{ block.type.label | localize }}</span>
        </div>

        @if(block.displayElement.displayType === blockDisplayTypeEnum.ONLINE) {
            <agpr-common-component-reader
                [data]="twigData"
                [key]="block.type.key"
            ></agpr-common-component-reader>
        } @else {
            <agpr-twig
                [id]="id + '_twig'"
                *ngIf="renderable"
                class="agpr-block-rendered"
                [twigTemplate]="block.type.twig"
                [data]="twigData"
                [preventChildFocus]="true"
            >
            </agpr-twig>
        }
        <div
            class="agpr-block-overlay agpr-block-dragHandle"
            [ngClass]="{
                'agpr-block-overlay--disabled': !block.actionable
            }"
        ></div>
    </div>

    <div class="agpr-block-hoverBorder"></div>
</div>
<div class="agpr-blockError">
    <agpr-form-message
        *ngFor="let error of block.errors"
    >
        {{ error | localize }}
    </agpr-form-message>
</div>
<div #scrollTarget></div>
